<div class="qb-w-100 qb-h-100 qb-challenge-parent-div">
  <div class="qb-heading-main-container">
    <div>
      <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="qb-challenge-button-container">
      <button
        class="primary-button"
        (click)="createChallenge()"
        data-button-name="Create New Challenge"
        [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
        [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
        [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 

      >
        <mat-icon class="qb-add-icon">add</mat-icon>
        {{ "COMMON_PAGE.CREATE_NEW_CHALLENGE" | i18nTranslate }}
      </button>
    </div>
  </div>
  <div class="qb-challenge-listing-container main-white-panel">
    <div class="qb-challenge-search-heading-container">
      <div class="module-heading">Challenge List</div>
      <div class="qb-offer-list-main-div">
        <div class="qb-form-div-search qb-form-search">
          <input
            #search
            class="qb-form-input"
            [(ngModel)]="filter.label"
            type="text"
            placeholder="Search by name"
            (input)="onKeySearch($event)"
          />
          <span
            class="material-icons-outlined icons-primary"
            *ngIf="filter.label.length == 0"
          >
            search
          </span>
          <span
            class="material-icons-outlined icons-primary cursor-pointer qb-close-icon"
            *ngIf="filter.label.length > 0"
            (click)="filter.label = ''; onKeySearch($event)"
          >
            close
          </span>
        </div>
        <div>
          <div
            class="filterButton button-hover-effect"
            (click)="openFilterDialog()"
            data-button-name="Filter"
          >
            <div style="display: flex">
              <span
                class="material-icons-outlined icons-primary"
                style="cursor: pointer"
                [matTooltipShowDelay]="200"
                [matTooltip]="'COMMON_PAGE.FILTERS' | i18nTranslate"
              >
                filter_alt
              </span>
            </div>
          </div>
        </div>
        <div *ngIf="selectedChallengeListPageWise[page].length > 0">
          <div
            class="filterButton button-hover-effect"
            (click)="deleteSelectedChallenge()"
            data-button-name="Delete"
          >
            <div style="display: flex">
              <span
                class="material-icons-outlined icons-primary"
                style="cursor: pointer"
                [matTooltipShowDelay]="200"
                [matTooltip]="'COMMON_PAGE.DELETE' | i18nTranslate"
              >
                delete
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-main">
      <div class="table-header">
        <div class="header-items-top">
          <!-- <mat-checkbox
            *ngIf="(challengeList !== null || length > 0) && !tableLoading"
            [checked]="
              selectedChallengeListPageWise[page].length ===
                getChallengeListLength(challengeList) &&
              getChallengeListLength(challengeList) > 0
            "
            [indeterminate]="
              selectedChallengeListPageWise[page].length > 0 &&
              selectedChallengeListPageWise[page].length !==
                getChallengeListLength(challengeList)
            "
            (change)="checkCampaignList($event.checked, 'all', null)"
            color="primary"
          >
          </mat-checkbox> -->
          <span>{{ "CAMPAIGN_PAGE.CHALLENGE_NAME" | i18nTranslate }}</span>
        </div>
        <span class="header-items-top">{{
          "CAMPAIGN_PAGE.SEG_TIERS" | i18nTranslate
        }}</span>
        <span class="header-items-top narrow-flex"
          >{{ "CAMPAIGN_PAGE.TYPE" | i18nTranslate }}
        </span>
        <span class="header-items-top narrow-flex">{{
          "CAMPAIGN_PAGE.STATUS" | i18nTranslate
        }}</span>
        <span class="header-items-top narrow-flex"
          >{{ "CAMPAIGN_PAGE.LAST_MOD" | i18nTranslate }}
        </span>
        <span class="header-items-top super-narrow-flex"> Actions </span>
      </div>
      <div style="color: #222222; overflow: auto">
        <div *ngIf="tableLoading">
          <div>
            <div>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  padding: 30px 0px;
                "
              >
                <app-qubriux-loading
                  [size]="65"
                  [loadingText]="'Fetching your Journeys...'"
                ></app-qubriux-loading>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="challengeList == null || length <= 0"
          class="empty-customers-div"
        >
          <div>{{ "CAMPAIGN_PAGE.NO_DATA_AVAILABLE" | i18nTranslate }}</div>
        </div>
        <div
          *ngFor="let item of challengeList | keyvalue : sortByKeyDesc;  let i = index"
          class="qb-d-flex"
        >
          <div class="header-items" *ngIf="!tableLoading">
            <div class="qb-d-flex qb-ai-center qb-mb-4">
              <!-- <mat-checkbox
                [checked]="checkIfPresent(item.value.strategy.id)"
                (change)="
                  checkChallengeList(
                    $event.checked,
                    'single',
                    item.value.strategy.id
                  )
                "
                color="primary"
              >
              </mat-checkbox> -->
            </div>
            <div class="qb-camp-name-wrapper">
              <div class="strategy-name">
                <span
                  [matTooltip]="item?.value?.challengeName"
                  matTooltipClass="ex-tooltip-red1"
                  matTooltipShowDelay="500"
                  (click)="editChallenge(item.key)"
                  class="cursor-pointer"
                  [innerHTML]="
                    convertMarkdownToHtml(item?.value?.challengeName || '----')
                  "
                ></span>
              </div>
              <!-- <div
                style="font-size: 10px"
                class="mini-list-item"
                [matTooltip]="
                  'Created by ' +
                  (getCreatedByData(
                    item?.value?.strategy?.created_by,
                    'storeName'
                  )
                    ? getCreatedByData(
                        item?.value?.strategy?.created_by,
                        'storeName'
                      ) +
                      '\n' +
                      (getCreatedByData(
                        item?.value?.strategy?.created_by,
                        'userEmail'
                      ) || '')
                    : getCreatedByData(
                        item?.value?.strategy?.created_by,
                        'storeName'
                      ) || '')
                "
                matTooltipClass="custom-tooltip"
              >
                <span class="material-symbols-outlined">person_edit</span>
                {{
                  getCreatedByData(
                    item?.value?.strategy?.created_by,
                    "storeName"
                  )
                }}
              </div> -->
            </div>
          </div>
          <div style="position: relative; display: block" class="header-items">
            <div *ngIf="isLeads[item.key]" class="mini-list-item-3">
              All Leads
            </div>
            <div
              *ngIf="isCustomer[item.key]; else segmentList"
              class="mini-list-item-3"
            >
              My Customers
            </div>
            <ng-template #segmentList>
              <div class="mini-list-item-3">
                {{ campaignSegments[item.key][0] }}
              </div>
              <div
                *ngIf="campaignSegments[item.key]?.length > 1"
                [matMenuTriggerFor]="menu"
                class="see-more"
                (click)="$event.stopPropagation()"
              >
                See All {{ campaignSegments[item.key].length
                }}<span class="material-symbols-outlined"
                  >keyboard_double_arrow_right</span
                >
              </div>
              <mat-menu #menu="matMenu" class="custom-menu">
                <div
                  *ngFor="let name of campaignSegments[item.key]"
                  class="mini-list-item-3"
                >
                  {{ name }}
                </div>
              </mat-menu>
            </ng-template>
            <div style="display: flex">
              <span
                class="material-icons-outlined icons-primary"
                style="font-size: 15px; margin-top: 4px"
              >
                person
              </span>
              <div
                style="vertical-align: super; font-size: 10px; margin-top: 5px"
              >
                {{ customerCount[item.key] }}
              </div>
            </div>
          </div>

          <div class="header-items narrow-flex">
            <span
              *ngIf="item.value?.challengeType !== undefined"
              class="truncate"
            >
              {{ getTypeDisplayName(item?.value?.challengeType) }}
            </span>
            <span *ngIf="item?.value.challengeType === undefined">---</span>
          </div>

          <div class="header-items narrow-flex">
            <div>
              <div style="display: flex">
                <div>
                  <div
                    *ngIf="item.value.status == 'ACTIVE'"
                    class="material-icons icons-primary"
                    style="color: #97cb64; font-size: 16px"
                  >
                    flag
                  </div>

                  <div
                    *ngIf="item.value.status == 'DRAFT'"
                    class="material-icons icons-primary"
                    style="color: var(--main-font-grey2); font-size: 16px"
                  >
                    flag
                  </div>

                  <div
                    *ngIf="item.value.status == 'SCHEDULED'"
                    class="material-icons icons-primary"
                    style="color: #f7941d; font-size: 16px"
                  >
                    flag
                  </div>

                  <div
                    *ngIf="item.value.status == 'ENDED'"
                    class="material-icons icons-primary"
                    style="color: var(--main-font-red); font-size: 16px"
                  >
                    flag
                  </div>
                </div>
                <div class="campaign-status" [ngClass]="item.value.status">
                  {{ item?.value?.status | i18nDynamicTranslate : "POS_PAGE" }}
                </div>
              </div>
              <!-- <mat-slide-toggle
                *ngIf="
                  item.value.status == 'ACTIVE' ||
                  item.value.status == 'SCHEDULED'
                "
                (change)="
                  toggleStrategyStatus(
                    $event,
                    item,
                    getCreatedByData(item?.value?.created_by, 'qid'),
                    getCreatedByData(
                      item?.value?.strategy?.created_by,
                      'storeName'
                    )
                  )
                "
                [checked]="
                  item.value.status == 'ACTIVE' ||
                  item.value.status == 'SCHEDULED'
                "
                widget-id="15"
                event-id="12"
                object-type="custom"
                [attr.data-item-name]="
                  item.value.status == 'ACTIVE' ||
                  item.value.status == 'SCHEDULED'
                    ? 'strategy-list-deactivate'
                    : 'strategy-list-activate'
                "
              >
              </mat-slide-toggle> -->
            </div>
          </div>
          <div
            style="display: flex; justify-content: space-between"
            class="header-items narrow-flex"
          >
            {{
              getDateInTimeZone(item?.value?.lastModifiedDate, 'date')
                | date : getDateFormat("dd MMM yyyy")
            }}<br />{{ getDateInTimeZone(item?.value?.lastModifiedDate, 'time') | customTime }}
          </div>

          <div class="header-items super-narrow-flex">
            <button  
            *ngIf="appSubscriptionPlan"
            class="qb-disable-button-container"
            [matTooltip]="'CAMPAIGN_PAGE.EDIT' | i18nTranslate"
            [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('CAMPAIGN_PAGE.EDIT' | i18nTranslate)"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
            (click)="editChallenge(item.key)">
              <svg
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5625 10.7812L13.5625 9.78125C13.6458 9.69792 13.7396 9.67708 13.8438 9.71875C13.9479 9.76042 14 9.84375 14 9.96875V14.5C14 14.9167 13.8542 15.2708 13.5625 15.5625C13.2708 15.8542 12.9167 16 12.5 16H1.5C1.08333 16 0.729167 15.8542 0.4375 15.5625C0.145833 15.2708 0 14.9167 0 14.5V3.5C0 3.08333 0.145833 2.72917 0.4375 2.4375C0.729167 2.14583 1.08333 2 1.5 2H10.0625C10.1667 2 10.2396 2.05208 10.2812 2.15625C10.3229 2.26042 10.3021 2.35417 10.2188 2.4375L9.21875 3.4375C9.17708 3.47917 9.125 3.5 9.0625 3.5H1.5V14.5H12.5V10.9375C12.5 10.875 12.5208 10.8229 12.5625 10.7812ZM17.4688 4.46875L9.25 12.6875L6.4375 13C6.02083 13.0417 5.66667 12.9167 5.375 12.625C5.08333 12.3333 4.95833 11.9792 5 11.5625L5.3125 8.75L13.5312 0.53125C13.8854 0.177083 14.3125 0 14.8125 0C15.3125 0 15.75 0.177083 16.125 0.53125L17.4688 1.875C17.8229 2.22917 18 2.66667 18 3.1875C18 3.6875 17.8229 4.11458 17.4688 4.46875ZM14.375 5.4375L12.5625 3.625L6.75 9.4375L6.53125 11.4688L8.5625 11.25L14.375 5.4375ZM16.4062 2.9375L15.0625 1.59375C14.8958 1.44792 14.7396 1.44792 14.5938 1.59375L13.625 2.5625L15.4375 4.375L16.4062 3.40625C16.5521 3.26042 16.5521 3.10417 16.4062 2.9375Z"
                  fill="#4379EF"
                />
              </svg>
            </button>

            <!-- <svg
              *ngIf="appSubscriptionPlan"
              [matTooltip]="'CAMPAIGN_PAGE.CLONE' | i18nTranslate"
              class="cursor-pointer"
              (click)="editChallenge()"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5 0C14.9167 0 15.2708 0.145833 15.5625 0.4375C15.8542 0.729167 16 1.08333 16 1.5V11.5C16 11.9167 15.8542 12.2708 15.5625 12.5625C15.2708 12.8542 14.9167 13 14.5 13H13V14.5C13 14.9167 12.8542 15.2708 12.5625 15.5625C12.2708 15.8542 11.9167 16 11.5 16H1.5C1.08333 16 0.729167 15.8542 0.4375 15.5625C0.145833 15.2708 0 14.9167 0 14.5V4.5C0 4.08333 0.145833 3.72917 0.4375 3.4375C0.729167 3.14583 1.08333 3 1.5 3H3V1.5C3 1.08333 3.14583 0.729167 3.4375 0.4375C3.72917 0.145833 4.08333 0 4.5 0H14.5ZM11.3125 14.5C11.4375 14.5 11.5 14.4375 11.5 14.3125V13H4.5C4.08333 13 3.72917 12.8542 3.4375 12.5625C3.14583 12.2708 3 11.9167 3 11.5V4.5H1.6875C1.5625 4.5 1.5 4.5625 1.5 4.6875V14.3125C1.5 14.4375 1.5625 14.5 1.6875 14.5H11.3125ZM14.3125 11.5C14.4375 11.5 14.5 11.4375 14.5 11.3125V1.6875C14.5 1.5625 14.4375 1.5 14.3125 1.5H4.6875C4.5625 1.5 4.5 1.5625 4.5 1.6875V11.3125C4.5 11.4375 4.5625 11.5 4.6875 11.5H14.3125Z"
                fill="#4379EF"
              />
            </svg> -->

            <button
            class="qb-disable-button-container"
            *ngIf="appSubscriptionPlan"
            [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('CAMPAIGN_PAGE.DELETE' | i18nTranslate)"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
            (click)="deleteChallenge(item.key, item?.value?.challengeName)">
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.5 2.5C13.6458 2.5 13.7604 2.55208 13.8438 2.65625C13.9479 2.73958 14 2.85417 14 3V3.5C14 3.64583 13.9479 3.77083 13.8438 3.875C13.7604 3.95833 13.6458 4 13.5 4H13L12.3438 14.5938C12.3229 14.9896 12.1667 15.3229 11.875 15.5938C11.5833 15.8646 11.2396 16 10.8438 16H3.15625C2.76042 16 2.41667 15.8646 2.125 15.5938C1.83333 15.3229 1.67708 14.9896 1.65625 14.5938L1 4H0.5C0.354167 4 0.229167 3.95833 0.125 3.875C0.0416667 3.77083 0 3.64583 0 3.5V3C0 2.85417 0.0416667 2.73958 0.125 2.65625C0.229167 2.55208 0.354167 2.5 0.5 2.5H3.0625L4.125 0.71875C4.41667 0.239583 4.85417 0 5.4375 0H8.5625C9.14583 0 9.58333 0.239583 9.875 0.71875L10.9375 2.5H13.5ZM5.4375 1.5L4.8125 2.5H9.1875L8.5625 1.5H5.4375ZM10.8438 14.5L11.5 4H2.5L3.15625 14.5H10.8438Z"
                  fill="#4379EF"
                />
              </svg>
            </button>

          </div>
        </div>
      </div>
    </div>
    <div class="paginate-div">
      <mat-paginator
        style="background: #fff"
        [pageIndex]="page - 1"
        [length]="length"
        [pageSize]="size"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="refreshPaginateddata($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
